import React, { useEffect, useState } from 'react';
import ProgressBarComponent from './ProgressBarComponent';

const CardProgressBarComponent = (props: any) => {
    const [classModoDark, setClassModoDark] = useState(' bg-dark text-white'); 
    const [letraPainel, setletraPainel] = useState('#57f542'); 

        
    const [preferences, setPreferences] = useState<any | null>(() => {
        const storedPreferences = localStorage.getItem("preferences");
        return storedPreferences ? JSON.parse(storedPreferences) : [];
    });
    
    useEffect(() => {
        if(preferences.darkMode == true){
            setClassModoDark(' bg-dark text-white');
            setletraPainel('#57f542');
        } else {
            setClassModoDark(' bg-light');
        }
    }, []);

    return (
    <div className="card-group width-progress-bar m-1" onClick={props.onClick}>
        <div className={"card " + classModoDark}>
            <div className="card-body p-1" style={{fontSize: 12}}>
                <section className="d-flex m-1">
                    <div style={{width:'15%'}}>
                        <p className="card-text mx-1">DT</p>
                        <p className="card-text mx-1" style={{color: `${letraPainel}`}}>OK</p>
                    </div>
                    <div style={{width:'20%'}}>
                        <p className="card-text mx-1">Doca</p>
                        <p className="card-text mx-1" style={{color: `${letraPainel}`}}>{props.doca}</p>
                    </div>
                    <div style={{width:'40%'}}>
                        <p className="card-text mx-1">Status</p>
                        <p className="card-text mx-1" style={{color: `${letraPainel}`}}>{props?.status}</p>
                    </div>
                    <div style={{width:'25%'}}>
                        <p className="card-text mx-1">Placa</p>
                        <p className="card-text mx-1" style={{color: `${letraPainel}`}}>{props.placa}</p>
                    </div>
                    <div style={{width:'27%'}}>
                        <p className="card-text mx-1">Tempo</p>
                        <p className="card-text mx-1" style={{color: `${letraPainel}`}}>{props.tempo}</p>
                    </div>
                </section>
            </div>
            
            <ProgressBarComponent percentual={props.porcentagem} color={'#57f542'} className='my-2 mx-2' />
        </div>
    </div>
    );
}

export default CardProgressBarComponent
